var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreyPin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Grey_Pin_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 14.52 14.39",
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "current",
    d: "M4.42 8.89c-.75.88-3.36 3.6-4.11 4.48-.2.23-.2.5-.01.69.19.19.45.19.68-.01.64-.53 3.14-2.9 3.78-3.44.29-.24.58-.49.89-.74-.37-.37-.74-.74-1.11-1.12-.05.05-.08.1-.12.14zm5.26 3.46c.54-.6.51-1.64.03-2.79l.03-.06c1.09-1.46 2.17-2.92 3.25-4.38l.15.15c.24.24.63.24.88 0l.08-.07c.24-.24.24-.63 0-.88L10.09.31a.628.628 0 00-.88 0l-.07.08c-.24.24-.24.63 0 .88l.21.21C7.86 2.56 6.39 3.64 4.9 4.72h-.01c-1.19-.5-2.27-.55-2.86.03-.06.07-.24.28-.02.51l7.13 7.13c.25.25.46.04.54-.04zM6.92 5.97c-.3-.24-.61-.47-.91-.66 1.31-1.07 2.63-2.14 3.95-3.22l.69.69-3.73 3.19z",
    fillRule: "evenodd",
    clipRule: "evenodd"
  })));
}
export default SvgGreyPin;